// extracted by mini-css-extract-plugin
export default {"swipeable-container":"swipeable_swipeable-container__DnLqL","swipeable-card":"swipeable_swipeable-card__VwqT+","delete-button":"swipeable_delete-button__lFEKR"};